import styled from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";
import { sidebarMobileHeight, sidebarWidth } from "./Sidebar.style";
import { UIProps } from "~/types/style";

interface IPageWrapper extends UIProps {
  padding: string;
  $isDashboard?: boolean;
  /** Desktop fixed sidebar width (tablet+); keeps main content aligned with rail. */
  $sidebarWidthPx?: number;
}

export const PageWrapper = styled.div<IPageWrapper>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: calc(100vh - ${sidebarMobileHeight}px);
  max-height: calc(100vh - ${sidebarMobileHeight}px);
  overflow-y: auto;
  /* Avoid 100vw: it ignores the scrollbar gutter and overflows the layout. */
  position: fixed;
  left: 0;
  right: 0;
  top: ${sidebarMobileHeight}px;
  width: auto;
  padding: ${getSize(1.25)};
  background-color: ${({ $isDashboard, theme }) =>
    $isDashboard ? "#F8F9FA" : theme.colors.backgroundSecondary};
  overflow-y: scroll;

  ${responsive("tablet")} {
    min-height: 100vh;
    max-height: 100vh;
    padding: ${({ padding }) => padding};
    background-color: ${({ $isDashboard, theme }) =>
      $isDashboard ? "#F8F9FA" : theme.colors.backgroundSecondary};
    width: calc(
      100vw - ${({ $sidebarWidthPx }) => $sidebarWidthPx ?? sidebarWidth}px
    );
    top: 0;
    left: ${({ $sidebarWidthPx }) => $sidebarWidthPx ?? sidebarWidth}px;
    transition:
      width 0.2s ease,
      left 0.2s ease;
  }

  @media (max-width: 768px) {
    overflow-x: hidden;
  }
  @media (max-width: 1024px) {
    overflow-x: hidden;
  }
`;

export const PageWrapperFullscreen = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  width: 100vw;
  background-color: ${getColor("background")};
`;

export const PageMaxWidth = styled.div`
  padding-left: ${getSize(1.5)};
  padding-right: ${getSize(1.5)};
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  box-sizing: border-box;

  ${responsive("tablet", true)} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-left: auto;
`;
